<div class="autocomplete-box">
  <p-autocomplete
    [(ngModel)]="clients"
    [suggestions]="clientList()"
    (completeMethod)="search($event)"
    (onSelect)="onClientChange($event.value)"
    (onUnselect)="onClientChange($event.value)"
    [placeholder]="placeholder()"
    [multiple]="multiple()"
    [disabled]="disabled()"
    [required]="required()"
    [showEmptyMessage]="true"
    minQueryLength="3"
  >
    <ng-template let-client #item>
      <div class="p-helper-clearfix">
        {{ client.getName() }}
      </div>
    </ng-template>
    <ng-template #empty>
      <app-autocomplete-empty-message
        [loading]="loading()"
        text="Account not found"
      ></app-autocomplete-empty-message>
    </ng-template>
  </p-autocomplete>
</div>
